module.exports = "<p>\n  create-referral works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/main/referral/create-referral/create-referral.component.html
// module id = ../../../../../src/app/main/referral/create-referral/create-referral.component.html
// module chunks = main